export const emojiMap: Record<string, string> = {
    // Emotikony
    ':grin:': '😁',
    ':joy:': '😂',
    ':rofl:': '🤣',
    ':wink:': '😉',
    ':heart_eyes:': '😍',
    ':kissing_heart:': '😘',
    ':kissing:': '😗',
    ':blush:': '😊',
    ':relaxed:': '☺️',
    ':unamused:': '😒',
    ':pensive:': '😔',
    ':worried:': '😟',
    ':cry:': '😢',
    ':sob:': '😭',
    ':angry:': '😠',
    ':rage:': '😡',
    ':tired_face:': '😫',
    ':fearful:': '😨',
    ':cold_sweat:': '😰',
    ':sweat:': '😓',
    ':scream:': '😱',
    ':astonished:': '😲',
    ':flushed:': '😳',
    ':sleeping:': '😴',
    ':zzz:': '💤',
    ':smirk:': '😏',
    ':neutral_face:': '😐',
    ':expressionless:': '😑',
    ':confused:': '😕',
    ':confounded:': '😖',
    ':disappointed:': '😞',
    ':face_with_raised_eyebrow:': '🤨',
    ':face_with_rolling_eyes:': '🙄',
    ':nauseated_face:': '🤢',
    ':face_vomiting:': '🤮',
    ':face_with_thermometer:': '🤒',
    ':face_with_head_bandage:': '🤕',
    ':money_mouth_face:': '🤑',
    ':star_struck:': '🤩',
    ':partying_face:': '🥳',

    // Různá gesta
    ':thumbs_up:': '👍',
    ':thumbs_down:': '👎',
    ':clap:': '👏',
    ':wave:': '👋',
    ':ok_hand:': '👌',
    ':raised_hands:': '🙌',
    ':pray:': '🙏',
    ':muscle:': '💪',
    ':point_right:': '👉',
    ':point_left:': '👈',
    ':point_up:': '☝️',
    ':point_down:': '👇',

    // Srdce a láska
    ':heart:': '❤️',
    ':blue_heart:': '💙',
    ':green_heart:': '💚',
    ':yellow_heart:': '💛',
    ':purple_heart:': '💜',
    ':broken_heart:': '💔',
    ':heartbeat:': '💓',
    ':two_hearts:': '💕',
    ':sparkling_heart:': '💖',
    ':heartpulse:': '💗',

    // Zvířata
    ':dog:': '🐶',
    ':cat:': '🐱',
    ':mouse:': '🐭',
    ':rabbit:': '🐰',
    ':bear:': '🐻',
    ':panda_face:': '🐼',
    ':lion_face:': '🦁',
    ':tiger:': '🐯',
    ':horse:': '🐴',
    ':cow:': '🐮',
    ':pig:': '🐷',
    ':frog:': '🐸',
    ':octopus:': '🐙',
    ':snake:': '🐍',
    ':bird:': '🐦',
    ':baby_chick:': '🐤',
    ':penguin:': '🐧',
    ':koala:': '🐨',
    ':monkey_face:': '🐵',
    ':chicken:': '🐔',
    ':whale:': '🐳',
    ':dolphin:': '🐬',
    ':elephant:': '🐘',
    ':crocodile:': '🐊',
    ':gorilla:': '🦍',
    ':unicorn:': '🦄',

    // Jídlo a pití
    ':apple:': '🍎',
    ':banana:': '🍌',
    ':watermelon:': '🍉',
    ':grapes:': '🍇',
    ':strawberry:': '🍓',
    ':pineapple:': '🍍',
    ':lemon:': '🍋',
    ':cherries:': '🍒',
    ':peach:': '🍑',
    ':hotdog:': '🌭',
    ':pizza:': '🍕',
    ':hamburger:': '🍔',
    ':fries:': '🍟',
    ':spaghetti:': '🍝',
    ':taco:': '🌮',
    ':sushi:': '🍣',
    ':beer:': '🍺',
    ':coffee:': '☕',

    // Doprava
    ':taxi:': '🚕',
    ':bus:': '🚌',
    ':truck:': '🚚',
    ':airplane:': '✈️',
    ':helicopter:': '🚁',
    ':rocket:': '🚀',
    ':ship:': '🚢',
    ':train:': '🚆',
    ':bicycle:': '🚲',
    ':motorcycle:': '🏍️',
    ':scooter:': '🛴',

    // Příroda a počasí
    ':sun:': '☀️',
    ':cloud:': '☁️',
    ':rainbow:': '🌈',
    ':snowflake:': '❄️',
    ':fire:': '🔥',
    ':crescent_moon:': '🌙',
    ':star:': '⭐',
    ':cactus:': '🌵',
    ':tulip:': '🌷',
    ':rose:': '🌹',
    ':sunflower:': '🌻',

    // Ostatní
    ':skull:': '💀',
    ':ghost:': '👻',
    ':alien:': '👽',
    ':robot:': '🤖',
    ':crown:': '👑',
    ':gift:': '🎁',
    ':balloon:': '🎈',
    ':confetti_ball:': '🎊',
    ':trophy:': '🏆',
    ':medal:': '🏅',
    ':moneybag:': '💰',
    ':gem:': '💎',
    ':hourglass:': '⏳',
    ':alarm_clock:': '⏰',
    ':calendar:': '📅',
    ':email:': '📧',
    ':light_bulb:': '💡',
    ':wrench:': '🔧',
    ':hammer:': '🔨',
    ':bomb:': '💣',
    ':lock:': '🔒',
    ':key:': '🔑',
};

export const emojis = Object.keys(emojiMap);
